import { CARD_STYLES, LAKE, SEASON } from "./VerseCard";
import { currentSeasonIndex } from "./SeasonalHero";

export const TESTIMONY_STYLES = [{ id: "plain", label: "Plain" }, ...CARD_STYLES];

export function styleFrame(style?: string) {
  if (style === "lake") return { cls: "rounded-2xl p-6 text-white sm:p-8", ink: "text-white", bg: { backgroundImage: `linear-gradient(180deg, rgba(15,23,42,.45), rgba(15,23,42,.8)), url(${LAKE})`, backgroundSize: "cover", backgroundPosition: "center" } };
  if (style === "season") {
    const [a, b, dark] = SEASON[currentSeasonIndex()];
    return { cls: "rounded-2xl p-6 text-white sm:p-8", ink: "text-white", bg: { backgroundImage: `linear-gradient(rgba(15,23,42,.42), rgba(15,23,42,.42)), linear-gradient(135deg, ${dark}, ${a} 60%, ${b})` } };
  }
  if (style === "parchment") return { cls: "rounded-2xl border-4 border-double border-[#B7791F] bg-[#FBF4E6] p-6 sm:p-8", ink: "text-[#3B2A1A]", bg: { boxShadow: "inset 0 0 60px rgba(180,140,90,.25)" } };
  return null;
}

export function StylePicker({ value, onChange }: { value: string; onChange: (s: string) => void }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="testimony-style-picker">
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">Background</span>
      {TESTIMONY_STYLES.map((s) => {
        const f = styleFrame(s.id);
        return (
          <button key={s.id} type="button" data-testid={`testimony-style-${s.id}`} onClick={() => onChange(s.id)} aria-pressed={value === s.id}
            className={`flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold transition-all ${value === s.id ? "border-[#C86D51] bg-[#FBF3EC] text-[#B35A3F] ring-2 ring-[#C86D51]/30" : "border-[#E2DBCE] bg-white text-slate-600 hover:bg-[#FAF7F2]"}`}>
            <span className={`h-5 w-5 rounded-full ${f ? "" : "border border-[#E2DBCE] bg-white"} ${s.id === "parchment" ? "border-2 border-[#B7791F] bg-[#FBF4E6]" : ""}`} style={f && s.id !== "parchment" ? f.bg : undefined} />
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
